import Vue from "vue";
import VueRouter from "vue-router";
//import store from "../store";

Vue.use(VueRouter)

  const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/news/:page?",
    name: "News",
    component: () => import(/* webpackChunkName: "news" */ "../views/News.vue")
  },
  {
    path: "/news-item/:id?",
    name: "NewsItem",
    component: () => import(/* webpackChunkName: "news-item" */ "../views/NewsItem.vue")
  },
  {
    path: "/projects/:page?",
    name: "Projects",
    component: () => import(/* webpackChunkName: "projects" */ "../views/Projects.vue")
  },
  {
    path: "/project-item/:id?",
    name: "ProjectItem",
    component: () => import(/* webpackChunkName: "project-item" */ "../views/ProjectItem.vue")
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: () => import(/* webpackChunkName: "contacts" */ "../views/Contacts.vue")
  },
  {
    path: "/donations",
    name: "Donations",
    component: () => import(/* webpackChunkName: "donate" */ "../views/Donations.vue")
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});

// router.beforeEach((to, from, next) => {
//   console.log(store.state.lang);
//   console.log(to.path);
//   let path = to.path;
//   to.path = path + "?lang=" + store.state.lang;
// next();
// });

export default router
